var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 97,
    viewBox: "0 0 268 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M0.5 0.5H265.5V94.5H0.5z",
    transform: "translate(-521.000000, -397.000000) translate(422.000000, 397.000000) translate(100.127823, 0.000000) translate(0.354033, 0.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M0 24.207H266V25.207H0zM0 47.5H266V48.5H0z",
    transform: "translate(-521.000000, -397.000000) translate(422.000000, 397.000000) translate(100.127823, 0.000000) translate(0.354033, 0.000000)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M106.419.5H107.419V94.5H106.419zM132.546.5H133.546V94.5H132.546zM159.379.5H160.379V94.5H159.379zM185.505.5H186.505V94.5H185.505zM212.338.5H213.338V94.5H212.338z",
    transform: "translate(-521.000000, -397.000000) translate(422.000000, 397.000000) translate(100.127823, 0.000000) translate(0.354033, 0.000000) translate(26.344231, 0.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M79.086 0L79.792 0 79.792 95 79.086 95zM52.96 0L53.666 0 53.666 95 52.96 95zM26.127 0L26.833 0 26.833 95 26.127 95zM0 0L.706 0 .706 95 0 95z",
    transform: "translate(-521.000000, -397.000000) translate(422.000000, 397.000000) translate(100.127823, 0.000000) translate(0.354033, 0.000000) translate(26.344231, 0.000000)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M0 71.25H266V72.25H0z",
    transform: "translate(-521.000000, -397.000000) translate(422.000000, 397.000000) translate(100.127823, 0.000000) translate(0.354033, 0.000000)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#878D96",
    strokeLinecap: "square",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18.247 3.864 36.621 20.917 54.996 30.165 73.625 30.239 89.193 31.624 109.609 48.768 130.025 57.222 151.869 65.615 182.851 65.615 262 67",
    transform: "translate(-521.000000, -397.000000) translate(422.000000, 397.000000) translate(100.127823, 0.000000) translate(0.354033, 9.000000)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#878D96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L19.045 4.139 26.714 38.171 52.444 62.086 79.969 62.545 93.977 62.545 105.729 85.222 132.548 85.222 158.661 86 185.48 85.222 211.593 86 264 85.222",
    transform: "translate(-521.000000, -397.000000) translate(422.000000, 397.000000) translate(100.127823, 0.000000) translate(0.354033, 10.000000)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#878D96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18.308 4.139 37.639 27.158 52.106 38.067 71.85 38.527 87.024 39.094 104.906 52.784 124.856 62.213 158.277 71.409 263 73",
    transform: "translate(-521.000000, -397.000000) translate(422.000000, 397.000000) translate(100.127823, 0.000000) translate(0.354033, 10.000000)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.73334947.svg";
export { ForwardRef as ReactComponent };